import React from 'react';
import { FaUsers, FaBriefcase, FaAward, FaHandshake, FaShieldAlt, FaGraduationCap, FaFacebook, FaTwitter, FaLinkedin } from 'react-icons/fa';

const quickLinks = [
  { icon: <FaBriefcase className="text-blue-700 w-7 h-7 mb-2" />, title: 'البحث عن وظائف', desc: 'اكتشف أحدث الفرص وانضم لفريقنا المتميز.', cta: 'تصفح الوظائف', href: '#' },
  { icon: <FaUsers className="text-yellow-500 w-7 h-7 mb-2" />, title: 'انضم لشبكة المواهب', desc: 'سجّل بياناتك ليصلك جديد الفرص والمبادرات.', cta: 'سجّل الآن', href: '#' },
  { icon: <FaHandshake className="text-green-600 w-7 h-7 mb-2" />, title: 'قيمنا', desc: 'النزاهة، الجودة، التطوير، والعمل الجماعي.', cta: 'اعرف المزيد', href: '#' },
];

const whyUs = [
  { icon: <FaAward className="text-yellow-500 w-8 h-8 mb-2" />, title: 'مشاريع قومية كبرى', desc: 'نشارك في تنفيذ أهم المشاريع الوطنية في مصر.' },
  { icon: <FaGraduationCap className="text-blue-700 w-8 h-8 mb-2" />, title: 'فرص تطور مهني سريع', desc: 'برامج تدريب وتطوير مستمر لجميع الموظفين.' },
  { icon: <FaShieldAlt className="text-green-600 w-8 h-8 mb-2" />, title: 'بيئة عمل آمنة وداعمة', desc: 'نلتزم بأعلى معايير السلامة والدعم الوظيفي.' },
  { icon: <FaUsers className="text-blue-900 w-8 h-8 mb-2" />, title: 'برامج تدريب وشهادات', desc: 'شهادات معتمدة وفرص تعلم متقدمة.' },
];

export default function JoinUs() {
  return (
    <div className="font-cairo bg-gray-50">
      {/* هيدر رئيسي */}
      <header className="relative min-h-[420px] flex items-center justify-center overflow-hidden bg-gradient-to-b from-blue-900/80 via-blue-800/70 to-blue-900/90">
        <img src="/images/image1.jpg" alt="موقع بناء" className="absolute inset-0 w-full h-full object-cover object-center z-0 opacity-60" />
        <div className="absolute inset-0 bg-gradient-to-b from-blue-900/80 via-blue-800/70 to-blue-900/90 z-10" />
        <div className="relative z-20 text-center w-full flex flex-col items-center justify-center py-20 px-4">
          <h1 className="text-3xl md:text-5xl font-extrabold text-white mb-4 drop-shadow-lg">انضم إلى فريق يغيّر وجه البنية التحتية في مصر</h1>
          <p className="text-white/90 text-lg md:text-2xl font-light mb-8 max-w-2xl mx-auto">في مكة البركة، نبحث عن أفضل الكفاءات لنحقق إنجازاتنا القومية. ابنِ مستقبلك وشاركنا النجاح.</p>
          <a href="#apply" className="inline-block bg-gradient-to-r from-yellow-400 to-blue-600 text-white font-bold px-8 py-3 rounded-2xl text-lg shadow-lg hover:scale-105 hover:shadow-2xl transition-all duration-200">قدّم الآن</a>
        </div>
      </header>

      {/* كروت/أقسام سريعة */}
      <section className="container-custom max-w-5xl mx-auto py-12 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {quickLinks.map((item, idx) => (
            <div key={idx} className="bg-white rounded-2xl shadow-lg p-8 flex flex-col items-center text-center border border-gray-100 hover:shadow-2xl transition">
              {item.icon}
              <h3 className="font-bold text-lg mb-2 text-blue-900">{item.title}</h3>
              <p className="text-gray-600 text-sm mb-4">{item.desc}</p>
              <a href={item.href} className="inline-block bg-gradient-to-r from-blue-600 to-yellow-400 text-white font-semibold px-5 py-2 rounded-xl hover:scale-105 transition">{item.cta}</a>
            </div>
          ))}
        </div>
      </section>

      {/* قسم لماذا تنضم إلينا */}
      <section className="container-custom max-w-5xl mx-auto py-12 md:py-20">
        <h2 className="text-2xl md:text-3xl font-extrabold text-blue-800 mb-10 text-center">لماذا تنضم إلى مكة البركة؟</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {whyUs.map((f, i) => (
            <div key={i} className="bg-white rounded-2xl shadow-lg p-6 flex flex-col items-center text-center border border-gray-100 hover:shadow-2xl transition">
              {f.icon}
              <h3 className="font-bold text-lg mb-2 text-blue-900">{f.title}</h3>
              <p className="text-gray-600 text-sm">{f.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* تعريف عن الشركة */}
      <section className="container-custom max-w-4xl mx-auto py-12 md:py-20">
        <h2 className="text-2xl md:text-3xl font-extrabold text-blue-800 mb-6 text-center">عن مكة البركة للمقاولات</h2>
        <p className="text-gray-700 text-lg text-center max-w-2xl mx-auto">مكة البركة للمقاولات هي شركة مصرية رائدة نفذت عشرات المشاريع القومية العملاقة في مختلف أنحاء الجمهورية، وتتبنى أعلى معايير الجودة والسلامة المهنية، وتهدف لتمكين شباب مصر من تحقيق تطلعاتهم في بيئة عمل محترفة وداعمة.</p>
      </section>

      {/* Footer شامل */}
      <footer className="w-full bg-blue-900 text-white pt-12 pb-6 mt-8 border-t-4 border-yellow-400">
        <div className="container-custom max-w-6xl mx-auto flex flex-col md:flex-row md:justify-between gap-8 md:gap-0">
          <div className="mb-8 md:mb-0 flex flex-col gap-4">
            <img src="/images/logo.png" alt="شعار مكة البركة" className="h-12 mb-2" />
            <p className="text-sm text-blue-100 max-w-xs">شركة رائدة في قطاع المقاولات والبنية التحتية، نفخر بإنجازاتنا وشراكاتنا الوطنية.</p>
            <div className="flex gap-4 mt-2">
              <a href="#" className="w-8 h-8 bg-yellow-400 rounded-full flex items-center justify-center text-blue-900 font-bold"><FaFacebook /></a>
              <a href="#" className="w-8 h-8 bg-yellow-400 rounded-full flex items-center justify-center text-blue-900 font-bold"><FaTwitter /></a>
              <a href="#" className="w-8 h-8 bg-yellow-400 rounded-full flex items-center justify-center text-blue-900 font-bold"><FaLinkedin /></a>
            </div>
          </div>
          <div className="flex-1 grid grid-cols-2 md:grid-cols-3 gap-8">
            <div>
              <h4 className="font-bold mb-3 text-yellow-400">روابط سريعة</h4>
              <ul className="space-y-2 text-sm">
                <li><a href="#" className="hover:underline">من نحن</a></li>
                <li><a href="#" className="hover:underline">مشاريعنا</a></li>
                <li><a href="#" className="hover:underline">اتصل بنا</a></li>
                <li><a href="#" className="hover:underline">وظائف</a></li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold mb-3 text-yellow-400">بيانات التواصل</h4>
              <ul className="space-y-2 text-sm">
                <li>هاتف: <a href="tel:020224181844" className="hover:underline">020224181844</a></li>
                <li>البريد: <a href="mailto:info@meccaelbaraka.com" className="hover:underline">info@meccaelbaraka.com</a></li>
                <li>العنوان: 38 الملتقي العربي - شيراتون - القاهرة</li>
              </ul>
            </div>
            <div>
              <h4 className="font-bold mb-3 text-yellow-400">تابعنا</h4>
              <div className="flex gap-3">
                <a href="#" className="w-8 h-8 bg-yellow-400 rounded-full flex items-center justify-center text-blue-900 font-bold"><FaFacebook /></a>
                <a href="#" className="w-8 h-8 bg-yellow-400 rounded-full flex items-center justify-center text-blue-900 font-bold"><FaTwitter /></a>
                <a href="#" className="w-8 h-8 bg-yellow-400 rounded-full flex items-center justify-center text-blue-900 font-bold"><FaLinkedin /></a>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center text-blue-200 text-xs mt-8">© 2025 جميع الحقوق محفوظة لشركة مكة البركة للمقاولات</div>
      </footer>
    </div>
  );
}
